module.exports = __webpack_public_path__ + "static/media/video.88a5d498.webm";